import { User } from "../../types/api/UsersTypes";

export const getLicenseeInfo = (isLicenseeProfileComplete: boolean, user: User) => {
  if (isLicenseeProfileComplete && user?.team?.licensee_profile) {
    const licenseType = user?.team?.licensee_profile?.license_type?.name || null;
    return {
      license: licenseType,
      licensee: licenseType === 'Individual' 
        ? `${user.team.licensee_profile.first_name || ''} ${user.team.licensee_profile.last_name || ''}`.trim() || null
        : user.team.licensee_profile.company_name || null
    };
  } else {
    return {
      license: null,
      licensee: null
    };
  }
};